/* Brunch Health — Design Lab Next progressive enhancement */
(()=>{'use strict';
  const site=document.querySelector('.br-site');
  if(!site)return;

  const root=document.documentElement;
  const header=document.querySelector('.br-header');
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine=window.matchMedia('(hover:hover) and (pointer:fine)');
  let scrollRaf=0;

  site.classList.add('br-next-ready');

  const updateScroll=()=>{
    scrollRaf=0;
    const max=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
    const progress=Math.max(0,Math.min(1,window.scrollY/max));
    root.style.setProperty('--br-next-scroll',progress.toFixed(4));
    header?.classList.toggle('br-next-scrolled',window.scrollY>24);
  };
  const queueScroll=()=>{
    if(!scrollRaf)scrollRaf=requestAnimationFrame(updateScroll);
  };

  const setPointerVars=(el,event,tilt=3.5)=>{
    const r=el.getBoundingClientRect();
    const x=Math.max(0,Math.min(r.width,event.clientX-r.left));
    const y=Math.max(0,Math.min(r.height,event.clientY-r.top));
    const nx=(x/r.width)-.5;
    const ny=(y/r.height)-.5;
    el.style.setProperty('--br-spot-x',`${(x/r.width*100).toFixed(1)}%`);
    el.style.setProperty('--br-spot-y',`${(y/r.height*100).toFixed(1)}%`);
    el.style.setProperty('--br-card-rx',`${(-ny*tilt).toFixed(2)}deg`);
    el.style.setProperty('--br-card-ry',`${(nx*tilt).toFixed(2)}deg`);
  };
  const resetPointerVars=(el)=>{
    el.style.setProperty('--br-card-rx','0deg');
    el.style.setProperty('--br-card-ry','0deg');
    el.style.setProperty('--br-spot-x','50%');
    el.style.setProperty('--br-spot-y','50%');
  };

  const bindCard=(el)=>{
    if(el.dataset.brNextBound==='true')return;
    el.dataset.brNextBound='true';
    el.addEventListener('pointermove',event=>{
      if(reduce.matches||!fine.matches)return;
      setPointerVars(el,event,4);
    },{passive:true});
    el.addEventListener('pointerleave',()=>resetPointerVars(el),{passive:true});
  };

  const bindVisual=(el)=>{
    if(el.dataset.brNextVisual==='true')return;
    el.dataset.brNextVisual='true';
    el.addEventListener('pointermove',event=>{
      if(reduce.matches||!fine.matches)return;
      const r=el.getBoundingClientRect();
      const nx=((event.clientX-r.left)/r.width)-.5;
      const ny=((event.clientY-r.top)/r.height)-.5;
      el.style.setProperty('--br-rx',`${(-ny*3.2).toFixed(2)}deg`);
      el.style.setProperty('--br-ry',`${(nx*4.2).toFixed(2)}deg`);
    },{passive:true});
    el.addEventListener('pointerleave',()=>{
      el.style.setProperty('--br-rx','0deg');
      el.style.setProperty('--br-ry','0deg');
    },{passive:true});
  };

  const bindAll=()=>{
    document.querySelectorAll('.br-med-card,.bh-treatment-card,.bh-plan-card,.bh-info-card,.bh-included-grid article,.bh-how-cost-grid article,.bh-about-value-grid article,.contact-card,.compare-cards article').forEach(bindCard);
    document.querySelectorAll('.br-hero-art,.bh-about-collage,.bh-how-hero__visual,.bh-help-hero__visual,.bh-pricing-hero__visual,.bh-product-hero__visual').forEach(bindVisual);
  };

  window.addEventListener('scroll',queueScroll,{passive:true});
  window.addEventListener('resize',queueScroll,{passive:true});
  reduce.addEventListener?.('change',()=>{
    if(reduce.matches){
      document.querySelectorAll('[data-br-next-bound="true"]').forEach(resetPointerVars);
    }
  });

  updateScroll();
  bindAll();
  document.addEventListener('shopify:section:load',()=>{bindAll();updateScroll()});
})();